import { useEffect, useState } from "react";
import axios from "axios";
import { Card, Container } from "../../styles";

import { IoArrowBack, IoSearch, IoCubeOutline } from "react-icons/io5";
import { FiUserPlus } from "react-icons/fi";
import { PiIdentificationBadge, PiBlueprintLight } from "react-icons/pi";
import { FaPlus, FaCheck } from "react-icons/fa";
import { AiOutlineUser } from "react-icons/ai";
import { LuFolderSearch } from "react-icons/lu";
import { toast } from "react-toastify";

import { useAuth } from "../../../../../hooks/auth";
import { useUsers } from "../../../../../hooks/users";

export default function NewProject({ setStatus }) {
  const [name, setName] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchedUsers, setSearchedUsers] = useState([]); // novo estado para os usuários encontrados
  const [selectedUsers, setSelectedUsers] = useState([]);

  const { token, projeto, user } = useAuth();
  const { fetchUsers } = useUsers();

  const handleClose = () => {
    document.getElementById("create-projetos").style.display = "none";
  };

  const handleUsersFromProject = async (email) => {
    try {
      const response = await axios.post(
        `https://dev.vidal-app.com/users/email`,
        { email },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            projeto: projeto?._id,
            user: user._id,
          },
        }
      );

      // Verifica se a resposta é um array com resultados
      if (Array.isArray(response.data) && response.data.length > 0) {
        setSearchedUsers(response.data);
        console.log("Usuários encontrados:", response.data);
      } else {
        console.error("Nenhum usuário encontrado.");
        setSearchedUsers([]);
      }
    } catch (error) {
      console.error("Erro ao buscar usuário:", error);
      setSearchedUsers([]);
    }
  };

  useEffect(() => {
    if (searchTerm) {
      const delayDebounceFn = setTimeout(() => {
        handleUsersFromProject(searchTerm);
      }, 500);
      return () => clearTimeout(delayDebounceFn);
    }
    // Se não houver termo de busca, limpa a lista
    setSearchedUsers([]);
  }, [searchTerm]);

  const handleSelectUser = (user) => {
    // Verifica se o usuário já foi selecionado (comparando pelo _id)
    if (!selectedUsers.some((u) => u._id === user._id)) {
      setSelectedUsers([...selectedUsers, user]);
      // Limpa os resultados da busca
      setSearchedUsers([]);
      setSearchTerm("");
    }
  };

  const handleRemoveUser = (user) => {
    const updatedUsers = selectedUsers.filter((u) => u._id !== user._id);
    setSelectedUsers(updatedUsers);
  };

  const submit = async () => {
    try {
      const response = await axios.post(
        "https://dev.vidal-app.com/projetos",
        {
          nome: name,
          cnpj: cnpj,
          users: selectedUsers.map((user) => user._id),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Projeto criado com sucesso!");
      handleClose();
      console.log("Response:", response.data);
      // Aqui você pode fechar o modal ou atualizar o estado da aplicação
    } catch (error) {
      toast.error(
        `Erro ao criar Projeto: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  return (
    <Container id="create-projetos">
      <Card>
        <div className="header">
          <div className="btn" onClick={handleClose}>
            <IoArrowBack />
          </div>
          <FiUserPlus />
          <p>Criando Projeto </p>
        </div>

        <div className="display">
          <div className="item ativ">
            <div className="thumb">
              <div className="circle">
                <p>{name.charAt(0).toUpperCase()}</p>
                <FaPlus />
              </div>
            </div>
            <div className="content">
              <p>{name}</p>
              <p className="cnpj">{cnpj}</p>
            </div>
          </div>

          <div className="tag">
            <PiIdentificationBadge />
            <p>Identificação</p>
          </div>

          <div className="input">
            <AiOutlineUser />
            <input
              placeholder="Nome do projeto"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoComplete="off"
            />
          </div>

          <div className="input">
            <LuFolderSearch />
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="CNPJ"
              value={cnpj}
              onChange={(e) => setCnpj(e.target.value.replace(/\D/g, ""))}
              autoComplete="off"
            />
          </div>

          <div className="tag">
            <PiBlueprintLight />
            <p>Usuários</p>
          </div>
          <div className="search">
            <IoSearch />
            <input
              placeholder="Digite o nome do usuário"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleUsersFromProject(e.target.value);
                }
              }}
            />
          </div>
          <div className="display">
            {/* Exibe os usuários já selecionados */}
            {selectedUsers.map((user) => (
              <div
                key={user._id}
                className="card"
                onClick={() => handleRemoveUser(user)}
                style={{ opacity: 1 }}
              >
                <div className="thumb">
                  <div
                    className="circle"
                    style={{ backgroundColor: user.color }}
                  >
                    <p>{user.name[0].toUpperCase()}</p>
                  </div>
                </div>
                <div className="content">
                  <p>{user.name}</p>
                  <p>{user.email}</p>
                </div>
                <div className="check">
                  <FaCheck style={{ color: "green" }} />
                </div>
              </div>
            ))}

            {/* Exibe os usuários retornados da busca */}
            {searchedUsers.map((user) => {
              // Se o usuário já estiver selecionado, exibe com opacidade 1; caso contrário, 0.4
              const isSelected = selectedUsers.some((u) => u._id === user._id);
              return (
                <div
                  key={user._id}
                  className="card"
                  onClick={() => handleSelectUser(user)}
                  style={{ opacity: isSelected ? 1 : 0.4 }}
                >
                  <div className="thumb">
                    <div
                      className="circle"
                      style={{ backgroundColor: user.color }}
                    >
                      <p>{user.name[0].toUpperCase()}</p>
                    </div>
                  </div>
                  <div className="content">
                    <p>{user.name}</p>
                    <p>{user.email}</p>
                  </div>
                  <div className="check">
                    <FaCheck style={{ color: isSelected ? "green" : "gray" }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="bottom">
          <div className="btn" onClick={submit}>
            <p>CRIAR</p>
          </div>
        </div>
      </Card>
    </Container>
  );
}
